<template>
  <v-card
      width="250"
      outlined
  >
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>{{text}}</v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StatisticsBlock",
  props: ['title', 'text']
}
</script>

<style scoped>

</style>
